import './telemetry'
import './errorHandling'
import { hasExpiredBearerToken, deleteBearerToken } from '@vue/services/jwt.service'
import { Notyf } from 'notyf';

if(hasExpiredBearerToken()) {
  deleteBearerToken();
}

window.notify = new Notyf({
  types: [
    {
      type: 'info',
      backgroundColor: 'blue',
      icon: {
        className: 'toast info_toast',
        tagName: 'i',
        text: '',
      },
    },
    {
      type: 'error',
      backgroundColor: 'red',
      icon: {
        className: 'toast error_toast',
        tagName: 'i',
        text: '',
      },
    },
    {
      type: 'warning',
      backgroundColor: 'orange',
      icon: {
        className: 'toast warning_toast',
        tagName: 'i',
        text: '',
      },
    },
  ],
  duration: 4000,
})

